import gql from 'graphql-tag'

export default gql`
  query getExpert($id: String!) {
    getExpert(id: $id) {
      id
      address {
        id
        address1
        address2
        zipCode
        region
        city
      }
      certificates
      education {
        id
        degree
        endDate
        major
        schoolName
        startDate
      }
      externalProjects {
        id
        companyRevenueModel
        description
        endDate
        financialTags
        fundingSources
        hoursMonthly
        hoursTotal
        industryTags
        isInternational
        isRecurring
        projectSize
        softwareTags
        startDate
        title
        annualCompanyRevenueRange
        companySize
        companyType
        onsite
      }
      languages
      legacyFreelancerId
      legacyMetadata {
        applicationStatus
        primaryServiceLine
      }
      paroIncomeStatus
      hasCurrentClients
      publications {
        id
        publisher
        title
        url
      }
      personalSummary {
        id
        aboutYourself
        accomplishments
        comments
        mostImpressiveProject
        paroReferrer
        topFinancialSkills
        topIndustries
        topSoftwareSkills
        whyFreelanceWork
      }
      workExperiences {
        id
        description
        employer
        endDate
        financialTags
        industryTags
        isCurrentEmployer
        softwareTags
        startDate
        title
      }
      workPreference {
        id
        contactStylePreference
        contactTimePreference
        isOpenToOnsite
        intendedMonthlyIncome
        projectType
        weeklyWorkloadHours
        totalFreelanceExperience
      }
      onboardingStep
    }
  }
`
